import 'intersection-observer'
import 'picturefill'
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
require('objectFitPolyfill')
